import { getNonUmbracoUrl } from "./getNonUmbracoUrl"

/**
 * Creates a localized URL by adding the locale prefix if needed
 *
 * @param url - The URL to localize (can be a full Umbraco URL or a relative path)
 * @param locale - The current locale (e.g., "he", "en", "ar", "ru")
 * @returns - A localized URL with the appropriate locale prefix if needed
 */
export function getLocalizedUrl(url?: string, locale?: string) {
  if (!url) return "/"

  // First process the URL to get a clean path
  const cleanUrl = getNonUmbracoUrl(url)

  // If no locale provided or the locale is the default "he", just return the clean URL
  if (!locale || locale === "he") {
    return cleanUrl
  }

  // For non-default locales, add the locale prefix
  // Handle absolute URLs (starting with http:// or https://)
  if (cleanUrl.startsWith("http")) {
    // For external URLs, we don't modify them
    return cleanUrl
  }

  // For root path ("/"), prepend the locale
  if (cleanUrl === "/") {
    return `/${locale}`
  }

  // For other internal paths, add the locale prefix while avoiding double slashes
  return `/${locale}${cleanUrl.startsWith("/") ? cleanUrl : `/${cleanUrl}`}`
}
